import { useEmailVerification } from '../hooks/useEmailVerification.js';
import { Button } from './ui.jsx';

/** The resend control, shared by the banner and the publish buttons' notice. */
export function ResendLink({ state, resend }) {
  if (state === 'sent') return <span className="text-ink-muted">Sent — check your inbox.</span>;
  return (
    <Button variant="outline" size="sm" onClick={resend} disabled={state === 'sending'}>
      {state === 'sending' ? 'Sending…' : state === 'error' ? 'Try again' : 'Resend link'}
    </Button>
  );
}

/**
 * Sits next to a disabled publish button and says why it is disabled.
 * Renders nothing once the email is confirmed.
 */
export function ConfirmEmailNotice({ className = '' }) {
  const { user, verified, state, resend } = useEmailVerification();
  if (verified) return null;
  return (
    <p className={`flex flex-wrap items-center gap-2 text-sm text-ink-muted ${className}`}>
      <span>
        <strong className="text-ink">Confirm your email to publish.</strong> We sent a link to{' '}
        {user.email}.
      </span>
      <ResendLink state={state} resend={resend} />
    </p>
  );
}
